import script from "./HintSquare.vue?vue&type=script&setup=true&lang=js"
export * from "./HintSquare.vue?vue&type=script&setup=true&lang=js"

import "./HintSquare.vue?vue&type=style&index=0&id=f996f59c&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f996f59c"]])

export default __exports__